import { schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const teamMessagesQuery = (teamId: string) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['teams', 'message', teamId],
    factory: collections.teams(teamId).messages,
    query: {
      name: `All messages for team ${teamId}`,
      orderBy: [['createdAt', 'desc']],
    },
  })
